import { InputText } from "primereact/inputtext";
import { FormActions, FormDialog, FormField, AdminCalendar } from "@/components/forms";
import { formStyles } from "@/components/forms/formStyles";
import { calendarValueToDateOrNull, ensureEndNotBeforeStart } from "@/lib/date-utils";

type SessionDraft = {
  startsAt: Date | null;
  endsAt: Date | null;
  label: string;
};

export function SessionDialog(props: {
  visible: boolean;
  editing: boolean;
  value: SessionDraft;
  onChange: (next: SessionDraft) => void;
  onSave: () => void;
  onCancel: () => void;
}) {
  const { value } = props;
  return (
    <FormDialog
      header={props.editing ? "Edit Session" : "Add Session"}
      visible={props.visible}
      onHide={props.onCancel}
    >
      <FormField id="session-starts" label="Start Date & Time" required>
        <AdminCalendar
          id="session-starts"
          value={value.startsAt}
          onChange={(e) => {
            const nextStart = calendarValueToDateOrNull(e.value);
            const nextEnd = ensureEndNotBeforeStart(nextStart, value.endsAt);
            props.onChange({
              ...value,
              startsAt: nextStart,
              endsAt: nextEnd,
            });
          }}
          showTime
          stepMinute={15}
          className="w-full"
          inputStyle={formStyles.input}
        />
      </FormField>

      <FormField id="session-ends" label="End Date & Time" required>
        <AdminCalendar
          id="session-ends"
          value={value.endsAt}
          onChange={(e) =>
            props.onChange({
              ...value,
              endsAt: calendarValueToDateOrNull(e.value),
            })
          }
          showTime
          stepMinute={15}
          className="w-full"
          inputStyle={formStyles.input}
        />
      </FormField>

      <FormField
        id="session-label"
        label="Label"
        optional
        helperText="e.g., Morning Session, Afternoon Session"
      >
        <InputText
          id="session-label"
          value={value.label}
          onChange={(e) => props.onChange({ ...value, label: e.target.value })}
          className="w-full"
          placeholder="e.g., Morning Session"
          style={formStyles.input}
        />
      </FormField>

      <FormActions
        primaryLabel="Save"
        onPrimary={props.onSave}
        secondaryLabel="Cancel"
        onSecondary={props.onCancel}
      />
    </FormDialog>
  );
}


